import { normalizeName, slugifyId } from "../utils/string";

const KEY = "cvtrg_profiles_v1";

export function loadProfiles() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed;
  } catch {
    return [];
  }
}

export function saveProfiles(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list || []));
  } catch {
    // ignore
  }
}

export function getByNameExact(name) {
  const q = normalizeName(name);
  if (!q) return undefined;
  const list = loadProfiles();
  return list.find(
    (p) => normalizeName(p.name).toLowerCase() === q.toLowerCase(),
  );
}

export function findMatches(q) {
  const list = loadProfiles();
  const needle = normalizeName(q).toLowerCase();
  if (!needle)
    return list
      .slice()
      .sort(
        (a, b) => b.usageCount - a.usageCount || b.lastUsedAt - a.lastUsedAt,
      );
  return list
    .filter((p) => normalizeName(p.name).toLowerCase().includes(needle))
    .sort((a, b) => b.usageCount - a.usageCount || b.lastUsedAt - a.lastUsedAt)
    .slice(0, 6);
}

export function upsertProfile(partial) {
  const name = normalizeName(partial?.name || "");
  if (!name) throw new Error("NAME_REQUIRED");
  const list = loadProfiles();
  const idx = list.findIndex(
    (p) => normalizeName(p.name).toLowerCase() === name.toLowerCase(),
  );
  const now = Date.now();
  if (idx >= 0) {
    const existing = list[idx];
    const merged = {
      ...existing,
      name: existing.name, // conserver la casse d'origine
      address: partial.address != null ? partial.address : existing.address,
      city: partial.city != null ? partial.city : existing.city,
      postalCode:
        partial.postalCode != null ? partial.postalCode : existing.postalCode,
      phone: partial.phone != null ? partial.phone : existing.phone,
      // nouvelle propriété icône
      icon: partial.icon != null ? partial.icon : existing.icon,
      lastUsedAt: now,
      usageCount: (existing.usageCount || 0) + 1,
    };
    list[idx] = merged;
    saveProfiles(list);
    return merged;
  }
  const created = {
    id: slugifyId(name),
    name,
    address: partial.address || undefined,
    city: partial.city || undefined,
    postalCode: partial.postalCode || undefined,
    phone: partial.phone || undefined,
    icon: partial.icon || undefined,
    lastUsedAt: now,
    usageCount: 1,
  };
  list.push(created);
  saveProfiles(list);
  return created;
}

// Supprime complètement un profil par son nom normalisé
export function removeProfileByName(name) {
  const q = normalizeName(name);
  if (!q) return false;
  const list = loadProfiles();
  const filtered = list.filter(
    (p) => normalizeName(p.name).toLowerCase() !== q.toLowerCase(),
  );
  saveProfiles(filtered);
  return true;
}

// Helper: renvoie l'emoji d'icône pour un nom, avec fallback optionnel
export function getIconForName(name, fallback) {
  const p = getByNameExact(name);
  return (p && p.icon) || fallback || undefined;
}
